import { createContext, useRef, useEffect, useCallback, useContext } from 'react';
import { API_ADR, AM_socketId, AM_UserDateTime, AMStats } from '../../ApiCenter/API_GET';
import { extractID } from  "../../ApiCenter/AudioMatePlayer";
import { InfoContext } from "../../ApiCenter/AM_BackGroundOP";
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { diffWords } from 'diff';

const _ = require('lodash');
const PronunciationContext = createContext();

const PronunciationsContextProvider = ({ children }) => {
    const ctx = useContext(InfoContext)
    const actorsWindow = useRef(null);
    const actorScriptSettings = useRef({});
    /* external windows */
    const extPlayerRef = useRef(null)
    const extPlayerRefCheck = useRef(false);
    const extVPlayerRef = useRef(null)
    const extVPlayerRefCheck = useRef(false);
    const activeLoopFromAudioModal = useRef(null)

    const actorsWindowCheck = useRef(false);
    const selChar = useRef(null);
    const selectedId = useRef(null);
    const unfilteredDataSource = useRef(null);
    const sourceAudioBase = useRef({});
    const sourceFileTypes = useRef({});
    const dataSourceIndex = useRef({});
    const dataTargetIndex = useRef({});
    const dataSource = useRef(null);
    const liveTask = useRef(null);
    const taskId = useRef(0);
    const userRoles = useRef([]);
    const audioMateRoles = useRef([]);
    const breadcrumb = useRef([]);
    const projectData = useRef({});
    const checkEnabled = useRef([]);
    const externalUser = useRef(true);
    const activeroles = useRef([])
    const qaTags = useRef([]);
    const containsContextLines = useRef(false);
    const multiSelection = useRef({});
    const markersArray = useRef({});
    const targetColumn = useRef(null);
    const playManual = useRef(null);
    const previousFiletype = useRef(null);
    const scriptPersistence = useRef({ 
        1: {filter: {}, columns: {}, selectedId: 0, columnsDefault: {}, showNottoadaptLines: 0, aditionalFilters: {}, sidepanelColumns: []}, 
        2: {filter: {}, columns: {}, selectedId: 0, columnsDefault: {}, showNottoadaptLines: 0, aditionalFilters: {}, sidepanelColumns: []},
        3: {filter: {}, columns: {}, selectedId: 0, columnsDefault: {}, showNottoadaptLines: 0, aditionalFilters: {}, sidepanelColumns: []},
        4: {filter: {}, columns: {}, selectedId: 0, columnsDefault: {}, showNottoadaptLines: 0, aditionalFilters: {}, sidepanelColumns: []},
        5: {filter: {}, columns: {}, selectedId: 0, columnsDefault: {}, showNottoadaptLines: 0, aditionalFilters: {}, sidepanelColumns: []},
        6: {filter: {}, columns: {}, selectedId: 0, columnsDefault: {}, showNottoadaptLines: 0, aditionalFilters: {}, sidepanelColumns: []},
        7: {filter: {}, columns: {}, selectedId: 0, columnsDefault: {}, showNottoadaptLines: 0, aditionalFilters: {}, sidepanelColumns: []},
     });
     const undoState = useRef({ 
        1: {undo: {}, redo: {}},
        2: {undo: {}, redo: {}},
        3: {undo: {}, redo: {}},
        4: {undo: {}, redo: {}},
        5: {undo: {}, redo: {}},
        6: {undo: {}, redo: {}},
        7: {undo: {}, redo: {}},
     });
     const sharedLinesOptions = useRef({
        completedPropagation: true,
        incompletedPropagation: false,
        textPropagation: true,
        remember: false,
     })

    const qaStatusTags = useRef([]);
    //const qaTagsGroups = useRef({});
    const qaStatusData = useRef({});  
    const refreshColumn = useRef(null);
    const refreshRow = useRef(null);
    const refreshAll = useRef(null);
    //const checkSharedLines = useRef(null);
    const highlightChanges = useRef(false);
    const intervalId = useRef(null);
    const updateAlert = useRef(null);
    const originalData = useRef([])
    const glossary = useRef([]);
    const glossaryMapping = useRef([]);
    const franchisesData = useRef({});
    const scriptIds = useRef(null);
    const tcColors = useRef(null);
    const rolesData = useRef([]);
    const extraColumnsHeaders = useRef({});
    const forceUnlock = useRef({});
    const targetFiletypes = useRef({});
    const kamFileTypesMap = useRef({});
    const tasksData = useRef(null);
    const sidePanelsColumns = useRef([]);
    const sharedLinesExist = useRef(false);
    const lastUpdate = useRef(
        {
            pmUpdate: null, //
            scriptTarget: null,
            scriptSource: null,
            actors: null,
            sourceAudio: null,
            pronunciations: null,
            unlockScript: null,
            scriptSettings: null, //Not needed
            targetFiletypes: null,
            metricsUpdate: null,
        }
    );
    const localTargetUpdates = useRef({});
    const localSourceUpdates = useRef({});
    const localSharedUpdates = useRef({});
    const updating = useRef(false);
    const progBar = useRef(null);
    const progBarUpdate = useRef(null);
    const updateSidePanel = useRef(null);
    const updateTTSPanel = useRef(null);
    const setPronGridDatasource = useRef(null);
    const refreshActorScript = useRef(null);
    const temporalDatasource = useRef([]);
    const refreshPMUpdates = useRef(null);
    const pmUpdatePending = useRef(0);
    const updateCounter = useRef(null);
    const scriptLinesLimit = useRef(6000);
    const scriptSettings = useRef({});
    const syncActorPannel = useRef(true);
    const fieldToCopy = useRef('target_filename');
    const fieldToCopyColumns = useRef([]);
    const uploadTags = useRef({});
    const xlocAudio = useRef({});
    const afterFilterData = useRef([]);
    const condFormatColumns = useRef([]);
    const conditionalFormats = useRef({});
    const asRecConfirm = useRef(false);
    const asRecMode = useRef(false);
    const asrecFilter = useRef([
        {value: 1, name: 'Checked', isChecked: true},
        {value: 0, name: 'Not checked', isChecked: true},
        {value: -1, name: 'Not recorded', isChecked: true},
    ])
    const filetypesFilter = useRef(null);
    const broadCastToReaper = useRef(false);
    const storedLine = useRef(null);
    const linkPrevSelLine = useRef(null);
    const deliveryScriptLocked = useRef(true);
    const showTranscription = useRef(false);
    const precheckFiletypeIds = useRef({});
    const headerOptions = useRef([
        {option: 'hide', type: 'button', tag: 'Hide column', icon: 'bi bi-eye-slash'}, 
        {option: 'changes', type: 'button', tag: 'Filter by changes', icon: 'bi bi-brightness-high', background: '#f3ef00ff'},
        {option: 'clearClip', type: 'button', tag: 'Clear clipboard filter', icon: 'bi bi-filter-circle', background: '#d70000', color: '#fff'}, 
        {option: 'clipboard', type: 'button', tag: 'Filter from clipboard', icon: 'bi bi-filter-circle', background: '#009cd7', color: '#fff'}, 
        {option: 'overriden', type: 'button', tag: 'Filter by overriden', icon: 'bi bi-share-fill', background: '#009cd7', color: '#fff'}, 
        {option: 'nonActive', type: 'button', tag: 'Hide non active', icon: 'bi bi-eye-slash', background: '#0d6efd', color: '#fff'}, 
        {option: 'adaptCheck', type: 'button', tag: 'Filter by OK', value: 'OK', icon: 'bi bi-hand-thumbs-up-fill', background: '#009b13', color: '#FFF'}, 
        {option: 'adaptCheck', type: 'button', tag: 'filter by TO CHECK', value: 'TO CHECK', icon: 'bi bi-hand-thumbs-down-fill', background: '#ff2f00', color: '#FFF'},
        {option: 'audioTranscript', type: 'button', tag: 'Hide differences', value: 'TO CHECK', icon: 'bi bi-plus-slash-minus', background: '#009b13', color: '#FFF'},
    ]);

    const resourceReplaceFields = useRef(new Set([
        'precheck_resource_name',
        'adaptation_resource_name',
        'recording_resource_name',
        'ai_resource_name',
        'postpro_resource_name',
        'qa_resource_name',
        'asrec_resource_name',
        'actor_name',
    ]));

    const addDataAndNormalize = (row, resources, characters, projectData) => {
        Object.entries(row).forEach(([k, v]) => {
            if(resourceReplaceFields.current.has(k)) {
                if(v) row[k] = resources[v] ?? null;
            } else if(Number.isInteger(v)) {
                row[k] = String(v);
            }
        });
        if(characters) row.character_name = characters[row.character_id];
        if(projectData) {
            row.script_name = projectData[row.script_language_id].script_name;
            row.batch_name = projectData[row.script_language_id].batch_name;
            row.project_name = projectData[row.script_language_id].project_name;
            row.language_code = projectData[row.script_language_id].language_code;
            row.dictionary_code = projectData[row.script_language_id].dictionary_code;
        }
    }

    const sharedLinesMenuRef = useRef(null);

    const setLastUpdate = (date, types) => {
        if(!types) { types = lastUpdate.current }
        Object.keys(types).forEach((k) => { lastUpdate.current[k] = date });
    }

    const updateProgressBar = (value, label, barNum) => {
        const bar = barNum === 1 ? progBar.current : progBarUpdate.current
        if (bar) { bar.updateProgress(value, label) };
    }
    
    const recStudioLocked =(r) => {
        
        if(ctx.userData.current?.admin > 1 || taskId.current === '6') return false;
        
        const scriptLangId = r.script_language_id;
        const data = scriptSettings.current?.[scriptLangId];
        if(data?.fullAccess === 1) return false;
        
        const scriptData = data?.tasksInfo?.[taskId.current];
        const studioId = scriptData?.recSites?.[r.recording_site_id]?.id;
        
        return !studioId || ctx.userData.current?.sites?.[studioId] ? false : true;
        
    }

    const columnsPermissions = (field) => {
        if(field === 'adaptation_check') return ctx.userData.current.admin > 1 || (ctx.userData.current?.permissions?.adaptCheckColumn && ctx.userData.current.ext_site === 0);
        if(field === 'asrec_confirm') return asRecConfirm.current;                                                                        
        return true;
    }

    const checkTargetFileExists = (el) => {
        if(!el.target_filetypes || !el.target_audio) { return 'Missing'}
        let textArray = [];
        const filetypesCount = Object.keys(el.target_filetypes).length;
        Object.keys(el.target_filetypes).forEach((e) => {
            if(!el.target_audio['0'] || !Object.keys(el.target_audio['0']).includes(e) || el.target_audio['0'][e].active !== 1) { 
                textArray.push(el.target_filetypes[e]); 
            }          
        })
        let allMissing = textArray.length === filetypesCount;
        if(el.alternatives_json.length > 0) {
            let altMissing = false;
            for (let i = 0; i < el.alternatives_json.length; i++) {
                if(el.alternatives_json[i].active === 1 && (!el.target_audio[el.alternatives_json[i].id] || Object.keys(el.target_audio[el.alternatives_json[i].id]).length < filetypesCount)) {
                    altMissing = true;
                    textArray.push('Alts');
                    break;
                }
            }
            if(!altMissing) allMissing = false;
        }
        if(allMissing) return 'Missing';
        return textArray.length > 0 ? "Missing " + textArray.join('/') : null;
    }

    const setQATag = (row, newIdx) => {
        const oldTagId = parseInt(row.qa_tag_id);
        newIdx = parseInt(newIdx);
        row.qa_tag_id = newIdx.toString();
        if(row.target_audio && [3,6].includes(parseInt(taskId.current)) && (
            [2,19,25].includes(newIdx) || 
            (oldTagId === 2 && newIdx === 1) ||
            ([19,25].includes(oldTagId) && [9,10,11,14,15,16].includes(newIdx))
        )) {
            const newVal = [2,19,25].includes(newIdx) ? 1 : -1;
            Object.values(row.target_audio).forEach(a => {
                Object.values(a).forEach(f => { 
                    const active = f.active + newVal; 
                    if(active > 0) f.active = active; 
                })
            });
            setUploadTagsValues(row);
            row.target_file_check = checkTargetFileExists(row);
        }
    }

    const getQaStatusMappedId = (id, row) => {
        if(parseInt(id) === 0 && row.qa_completed === '1') id = '17';
        return (qaStatusData.current.tags[id]?.taskMap?.[taskId.current] ?? id).toString();
    }

    const setBugFixingText = useCallback((r) => {
        if(parseInt(getQaStatusMappedId(r.qa_tag_id, r) ?? 0) === 0) return null;
        const showQaNotes = scriptSettings.current?.[r.script_language_id]?.showNotesInBugFixing === 1;
        const arr = r.bug_fixing_notes ? [...r.bug_fixing_notes] : [];
        if(showQaNotes && r.qa_notes) { arr.unshift({text: r.qa_notes}) }
        return arr.length > 0 ? arr.map(n => n.text).join(' | ') : null;
    }, [])

    const setPrecheckChatText = useCallback((r) => {
        const arr = r.precheck_chat_notes ? [...r.precheck_chat_notes] : [];
        return arr.length > 0 ? arr.map(n => n.text).join(' | ') : null;
    }, [])

    const setQAStatus = useCallback((row) => {
        row.qa_status = parseInt(row.qa_tag_id) === 0 && row.qa_completed === '1' ? '17|0' : row.qa_tag_id + '|' + row.qa_tag_severity_id;
        row.bug_fixing_text = setBugFixingText(row);
    }, [setBugFixingText])

    const checkDeactivated = (r) => {
        // 0 = No activable, 1 = Deactivated, 2 = Activated, 
        if(r.only_context_edit === '1') { return 0 } 
        if(r.activated_line === '0' && !scriptSettings.current[r.script_language_id].deactivableLine) { return 0 } 
        if(r.activated_line === '1' || (scriptSettings.current[r.script_language_id].deactivableLine && r.deactivated_line === '1')) { return 1 } 
        if(r.activated_line === '2' || (scriptSettings.current[r.script_language_id].deactivableLine && r.deactivated_line === '0')) { return 2 } 
    }

    const qaCoordOverride = useRef(null);

    const editPermissions = (field, myId, editable, prevDisabled) => {
        
        if(ctx.userData.current?.readOnly === 1) { return 1 }
        //0 = editable, 1 = locked, 2 = readOnly
        const task = parseInt(taskId.current);
        const compareTaskId = task === 7 ? 3 : task;
        const dataRow = unfilteredDataSource.current[myId];

        if(recStudioLocked(dataRow)) { return 2 }
        if(dataRow.only_context_edit === '1' || !editable) { return 2 }
        if(dataRow.only_context_edit === '2' && task < 4) { return 2 }
        if(checkDeactivated(dataRow) === 1) { return 2 }

        if(task === 6 && !['qa_status', 'delivery_completed', 'bug_fixing_text', 'precheck_chat_text'].includes(field)) return  deliveryScriptLocked.current ? 1 : 0; //All delivery script field unlocked 
        if(dataRow.target_locked === '1' && ['target_adapted', 'target_asrec'].includes(field)) { return 1 }
        if(selChar.current && dataRow.character_name !== selChar.current) { return 1 }

        const scriptLangId = dataRow.script_language_id;

        const qaStatus = parseInt(dataRow.qa_status?.split('|')?.[0] ?? dataRow.qa_tag_id);
        const qaStatusLocks = qaStatusData.current.tags[qaStatus].locks;

        if(qaCoordOverride.current === dataRow.script_data_language_id && task === 5 && ['target_asrec'].includes(field) && ctx.userData.current.roles.includes('13') && [7,10,15].includes(qaStatus)) { return 0 }
        if(task !== 6 && lineCompletedCheck(dataRow, 6)) { return 1 }
        if(task === 3 && asRecMode.current && field === 'recording_completed') return 1;
        if(!asRecMode.current && field === 'asrec_confirm') return 1;

        if(['qa_status','bug_fixing_text'].includes(field)) {
            const locks = qaStatusLocks.qaStatus?.[task];
            const lockedVal = !locks ? 0 : 1;
            return lockedVal
        } 

        if(field === 'precheck_chat_text') return 0;

        const qaStatusCheck = (qaStatus > 0 && ![5,6].includes(task)) || (![0,17].includes(qaStatus) && [5,6].includes(task));

        if(field.includes('_completed') && qaStatusCheck) { 
            const notCompleted = task !== 6 && dataRow[field] === '0' ? 0 : 1;
            return prevDisabled && !qaStatusLocks?.prev?.[task] ? 1 : !prevDisabled && qaStatusLocks.completed?.[task] ? notCompleted : 0; 
        }

        if(qaStatusCheck && field === 'bug_fixing_text') { return 0 }
        if(qaStatusCheck && !qaStatusLocks.edit[task] && field !== 'asrec_confirm') { return 0 }

        if(forceUnlock.current[scriptLangId] && forceUnlock.current[scriptLangId][task] && forceUnlock.current[scriptLangId][task].includes(field)) { return 0 }

        if(field === liveTask.current + '_notes') { return 0 }
        if(
            (!field.includes('_completed') && qaStatusLocks.edit[task] === 1) ||
            (field.includes('_completed') && qaStatusLocks.completed[task] === 1)
         ) return 1 

        if(compareTaskId < 6 && field.includes('_completed') && (dataRow[field] === '0' || !dataRow[field])) { return 0 }
        
        const asrecConfirmEnabled = scriptSettings.current?.[dataRow.script_language_id]?.asrecConfirmation === 1;
        if(compareTaskId === 3 && field === 'recording_completed' && asRecMode.current && asrecConfirmEnabled) return 1;

        const asRecConfirmCompleted = !asrecConfirmEnabled || dataRow.asrec_completed === '1' || !asRecMode.current;
        if(!asRecConfirmCompleted && field === 'asrec_confirm' && asRecMode.current && lineCompletedCheck(dataRow, 3)) return 0;
        
        let completedId = 0;
        completedId = dataRow.precheck_completed === '1' ? 2 : completedId;
        completedId = dataRow.adaptation_completed === '1' ? 3 : completedId;
        completedId = dataRow.ai_completed === '1' ? 3 : completedId;
        completedId = dataRow.recording_completed === '1' && asRecConfirmCompleted ? 4 : completedId;
        completedId = dataRow.postpro_completed === '1' ? 5 : completedId;
        completedId = dataRow.qa_completed === '1' ? 6 : completedId;
        completedId = dataRow.delivery_completed === '1' ? 7 : completedId;

        const taskOffset = asRecConfirmCompleted && field !== 'asrec_confirm' ? 1 : 2;
        if((compareTaskId + taskOffset) < completedId) return 1;
        
        completedId = field.includes('_completed') ? completedId - 1 : completedId;

        if (compareTaskId === 6 && !['delivery_completed', 'qa_status', 'pm_notes', 'language_notes', 'target_audio'].includes(field)) { return 1 }

        const onlyEdit = dataRow.only_context_edit === '2';
        if ([2,3].includes(compareTaskId) && onlyEdit) { return 2 }

        if(compareTaskId < completedId && field.includes('_completed')) { 
            const taskCompleted = dataRow[field] === '1';
            return !taskCompleted ? 0 : 1 
        } 

        if(compareTaskId === 3 && completedId < 6 && (!asRecConfirmCompleted || field === 'asrec_confirm')) return 0;
        if(compareTaskId < completedId) { return 1 }  
        if(compareTaskId === 6 && field === 'target_audio') return 1;

        return 0

    }
    
    const getConditionalColor = (row, field) => {
        const scriptLangId = row.script_language_id;
        const franchiseId = scriptSettings.current[scriptLangId]?.franchise_data?.id;
        const preset = conditionalFormats.current?.[franchiseId];
        
        if(!preset || !preset.length === 0) return null;
        const cellValue = (row?.[field] === undefined || row[field] === null ? '' : row[field]).toString().toLowerCase().trim();
        
        for (const p of preset) {    
            if(!p.columns || !p.columns?.[field]) continue; 
            for (const r of p.rules) {  
                for (const c of r.criterias) {
                    const operand = parseInt(c.operand);
                    const value = c.value[0].toLowerCase().trim();
                    if(operand === 0) {
                        if(cellValue === value) return r.color;
                    } else if(operand === 1) {
                        if(cellValue !== value) return r.color;
                    } else if(operand === 2) {
                        if(value && cellValue.includes(value)) return r.color;
                    } else if(operand === 3) {
                        if(value && !cellValue.includes(value)) return r.color;
                    } else if(operand === 4) {
                        if(value && cellValue.startsWith(value)) return r.color;
                    } else if(operand === 5) {
                        if(value && cellValue.endsWith(value)) return r.color;
                    } else if(operand === 6) {
                        if(cellValue !== null && cellValue !== '' && cellValue !== undefined && !isNaN(Number(cellValue) && cellValue > value)) return r.color;
                    } else if(operand === 7) {
                        if(cellValue !== null && cellValue !== '' && cellValue !== undefined && !isNaN(Number(cellValue) && cellValue < value)) return r.color;
                    } else if(operand === 8) {
                        if(cellValue !== null && cellValue !== '' &&  cellValue !== undefined && !isNaN(Number(cellValue))) {
                            const val1 = Number(c.value[0] === "" ? 0 : c.value[0]);
                            const val2 = Number(c.value[1] === "" ? 0 : c.value[1]);
                            if(cellValue >= Math.min(val1, val2) && cellValue <= Math.max(val1, val2)) return r.color;
                        } 
                    }  
                }
            }       
        };
        return null;
    }
    
    const setConditionalFormat = (ref, data, field, removeColor) => {
        let el = ref.parentElement;
        while (el && el.tagName !== 'TD') { el = el.parentElement }  
        const color = removeColor ? null : getConditionalColor(data, field);
        if(el) {
            el.style.background = color?.background ?? '';
            el.style.color = color?.color ?? ''; 
        }
    }

    const setFiletypes = () => {
        const filetypes = {};
        Object.entries(sourceFileTypes.current ?? {}).forEach(([k,v]) => {
            const key = v.toLowerCase();
            if(!filetypes.hasOwnProperty(key)) {
                filetypes[key] = {option: 'filetypes', type: 'button', value: [k], tag: v, icon: 'bi bi-square'};
            } else if(!filetypes[key].value.includes(k)) {
                filetypes[key].value.push(k);
            }
        })
        filetypesFilter.current = Object.values(filetypes);
        const selectedKey = Object.keys(precheckFiletypeIds.current)?.[0];
        if(selectedKey && filetypes.hasOwnProperty(selectedKey)) {
            precheckFiletypeIds.current[selectedKey] = filetypes[selectedKey].value;
            filetypes[selectedKey].icon = 'bi bi-check-square';
        } else {
            precheckFiletypeIds.current = {};
        }
    }

    const setPreCheckFiletype = (fileType, setFromId) => {
        if(setFromId) fileType = filetypesFilter.current?.find(t => t.value.includes(fileType))?.value || [];
        let selectedIds = {};
        filetypesFilter.current.forEach(f => {
            const selected = JSON.stringify(f.value) === JSON.stringify(fileType);
            f.icon = !selected ? 'bi bi-square' : 'bi bi-check-square';
            if(selected) selectedIds = {[f.tag.toLowerCase()]: f.value};
        })
        precheckFiletypeIds.current =  selectedIds;
    }

    const checkDiffs = useCallback((row, prevAnalysis) => {

        if(row.only_context_edit !== '0' || filetypesFilter.current?.length === 0) return null;

        if(!prevAnalysis) {
            const audioKey = row.source_link_id ? '|' +  row.source_link_id.toLowerCase().replace(/\\/g, '/') : null;
            const currentIds = Object.values(precheckFiletypeIds.current)?.[0];
            const ids = currentIds || (row.souce_types_id ? row.souce_types_id.split('|') : []);
            let audioText = null;
            let status = 0;
            for(let id of ids) {
                audioText = sourceAudioBase.current?.[id + audioKey]?.text;
                status = sourceAudioBase.current?.[id + audioKey]?.status;
                if(audioText) {
                    if(!currentIds) setPreCheckFiletype(id, true);
                    break;
                }
            }
            if(status === 0) {
                row.precheck_check = 'PENDING TRANSCRIPTION';
                row.audio_transcription = 'PENDING TRANSCRIPTION';
                return;
            } else if(status === 2 || !audioText) {
                row.precheck_check = 'MISSING TRANSCRIPTION';
                row.audio_transcription = 'MISSING TRANSCRIPTION';
                return;
            }
            row.audio_transcription = audioText;
        } else if(['PENDING TRANSCRIPTION', 'MISSING TRANSCRIPTION'].includes(row.precheck_check)) {
            return {result: [[2, row.precheck_check]], text1: null, text2: null};
        }

        let text1 = (!prevAnalysis ? row.source_text?.replace(/[^a-zA-Z0-9\s]/g, '') : row.audio_transcription) || '';
        let text2 = (!prevAnalysis ? row.audio_transcription?.replace(/[^a-zA-Z0-9\s]/g, '') : row.source_text) || '';

        if(prevAnalysis && prevAnalysis.text1 === text1 && prevAnalysis.text2 === text2) return {result: [], text1: null, text2: null};

        const changes = diffWords(text1, text2, {ignoreCase: true});
        
        if(prevAnalysis) {
            const result = [];
            changes.forEach(p => { 
                let id = p.removed ? 1 : p.added ? -1 : 0;
                if(id === 1 && !/[a-zA-Z0-9]/.test(p.value)) {
                    return;
                } else if(id === -1 && !/[a-zA-Z0-9]/.test(p.value)) {
                    id = 0;
                }
                result.push([id, p.value]); 
            });

            return {result, text1, text2};
        }

        const counters = {0: 0, 1: 0, "-1": 0}
        changes.forEach(p => {
            const key = p.removed ? -1 : p.added ? 1 : 0;
            const value = p.value.trim();
            if(!value) return;
            counters[key] += value.split(/\s+/).length || 0;
        })
        const total = Math.max(counters[-1], counters[1]) + counters[0];
        const percentage = counters[0] / total; 
        const sameLength = counters[-1] === counters[1] && Math.abs(text1.length - text2.length) < 4;
        const mayorTolerance = sameLength ? 0.6 : 0.8;
        let value = 'MATCH (SKIP)';
        if(percentage < mayorTolerance) {
            value = 'MAJOR DIFF (TO CHECK)';
        } else if(percentage < 1) {
            value = 'MINOR DIFF (TO CHECK)';
        }
        row.precheck_check = value;
    }, [])

    const changePrecheckFiletype = (fileType) => {
        setPreCheckFiletype(fileType);
        unfilteredDataSource.current.forEach(r => checkDiffs(r));
        refreshColumn.current('audio_transcription');
        refreshColumn.current('precheck_check');
        AMStats('script', `Change transcription filetype`, null, {
            scriptIds: scriptIds.current.split(',').map(Number),
            filetypeIds: fileType.map(Number),
        });
    }

    //const tokenizeInternational = (str) => {
    //    return Array.from(str.matchAll(
    //        /[\p{L}\p{N}]+|\p{Script=Han}|\p{Script=Hiragana}|\p{Script=Katakana}|\p{Script=Hangul}|\s+|./gu
    //    )).map(m => m[0]);
    //}

    //const compareWordsUniversal = (row) => {
    //    //const sourceText = row.source_text;
    //    //const audioText = row.source_precheck_text;
    //    //const oldTokens = tokenizeInternational(oldTextNorm || "");
    //    //const newTokens = tokenizeInternational(newTextNorm || "");
    //    return checkDiffs(row);
    //}

    const changeQaStatusOnComplete = (myId, accept) => {

        const data = unfilteredDataSource.current[myId];
        let nextId;
        let selectNext = 1;

        if(accept) { 
            nextId = qaStatusData.current.tags[data.qa_tag_id]?.locks?.next?.[taskId.current];
        } else {
            nextId = qaStatusData.current.tags[data.qa_tag_id].locks?.prev?.[taskId.current];
        }

        if(nextId === -1) {
            const log = data.qa_status_log ?? [];
            while (log?.length > 0 && log.at(-1)?.task === parseInt(taskId.current)) {
                log.pop();
            }
            nextId = log?.at(-1)?.id ?? -1;
            selectNext = 0;
        }

        return [isNaN(nextId) ? -1 : nextId, selectNext];

    }

    const setUploadTagsValues = (row) => {
        const audio = row.target_audio?.[0];
        if(!audio) {
            row.uploadTags = null;
            return;
        }
        const id = Math.max(...Object.values(audio).map(a => a.active === 1 ? a.upTagId : 0));
        const tagData = uploadTags.current?.[id];
        if(!tagData) {
            row.uploadTags = null;
        } else {
            row.uploadTags = `${tagData.tag} (${tagData.user} on ${AM_UserDateTime(tagData.date)})`;
        }
    }
    
    const xlocLineStatus = useCallback((r) => {

        const checkTaskCompleted = (task) => {
            const taskCode = tasksData.current[task].task_code
            const toIgnore = (
                checkDeactivated(r) === 1) ||
                r.only_context_edit === '1' || 
                (r.only_context_edit === '2' && [2, 3].includes(task)) || 
                ((!r[taskCode + '_estimation'] || r[taskCode + '_estimation'] === 0) && task < 6);   
            if(toIgnore) { return false }
            return r[taskCode + '_completed'] === '1' && !qaStatusData.current.tags[r.qa_tag_id].incompleted?.includes(task);
        }
        
        if(checkTaskCompleted(6)) return {param:"Audio Delivered", statusId: 6};
        if(checkTaskCompleted(5)) return {param:"Audio Recorded", statusId: 3};
        if(checkTaskCompleted(4)) return {param:"Audio Recorded", statusId: 3};
        if(checkTaskCompleted(3)) return {param:"Audio Recorded", statusId: 3};
        //if(checkTaskCompleted(2)) return "Adapted";
        return {param: "", statusId: 0};

    }, [])

    const lineCompletedCheck = useCallback((r, taskToCheck, ignoreDeactivated, ignoreCompleted = false, checkAsrecConfirm = false, skipAsrecConfirmDisabled = false) => {
        const task = taskToCheck ? taskToCheck : parseInt(taskId.current);
        const taskCode = tasksData.current[task].task_code
        const toIgnore = (!ignoreDeactivated && checkDeactivated(r) === 1)
                        || r.only_context_edit === '1' 
                        || (r.only_context_edit === '2' && [2, 3].includes(task)) 
                        || (!taskToCheck && selChar.current && r.character_name !== selChar.current)
                        || ((!r[taskCode + '_estimation'] || r[taskCode + '_estimation'] === 0) && task < 6);
        
        if(toIgnore) return true;
        if(ignoreCompleted) return false;
        let completed = r[taskCode + '_completed'] === '1' && !qaStatusData.current.tags[r.qa_tag_id].incompleted?.includes(task);

        if(checkAsrecConfirm && task === 3 && asRecMode.current && scriptSettings.current?.[r.script_language_id]?.asrecConfirmation  === 1) {
            completed = skipAsrecConfirmDisabled && !completed ? true : completed && r.asrec_completed === '1';
        }
        
        return completed;
    }, [])
    
    const xlocAudioId = (r) => {
        const filtypeId = scriptSettings.current?.[r.script_language_id].xlocUpdateAudio;
        const s3 = r.target_audio?.[0]?.[filtypeId]?.s3;
        return s3 ? parseInt(s3.split('target/')[1].split('.')[0]) : 0;
    }

    const setXlocStatusText = useCallback((r) => {
        if(!r.xlocId) {
            r.xloc_sync = null;
            return;
        }
        const values = [
            'Status: Disabled',
            'AsRec: Disabled',
            'Audio: Disabled',
        ];
        if(scriptSettings.current?.[r.script_language_id]?.xlocUpdateStatus === 1) {
            values[0] = `Status: ${xlocLineStatus(r)?.statusId !== parseInt(r.xloc_status[0]) ? 'Not Synched' : 'Synched'}`;
        }
        if(scriptSettings.current?.[r.script_language_id]?.xlocUpdateAsrec === 1) {
            values[1] = `AsRec: ${parseInt(r.xloc_status[1]) === 0 ? 'Not Synched' : 'Synched'}`;
        }
        if(scriptSettings.current?.[r.script_language_id]?.xlocUpdateAudio > 0) {
            const audioId = xlocAudioId(r);
            values[2] = `Audio: ${!audioId || parseInt(r.xloc_status[2]) !== audioId ? 'Not Synched' : 'Synched'}`;
        }
        r.xloc_sync = values.join(' | ');
    }, [xlocLineStatus])
    
    /* DOTS UI PROGRESSION */
    const projectTaskProgression2 = useCallback((props) => {
        
        setXlocStatusText(props);

        if(props.only_context_edit === '1') { return }

        const precheckStyle = props.precheck_completed === '0' ? "notcompleted" : "";
        const adaptStyle = props.adaptation_completed === '0' || !props.adaptation_completed ? "notcompleted" : "";
        const adaptNotNeeded = !props.adaptation_estimation && props.adaptation_completed === '1' ? "notneeded" : '';   
        
        props.rec_date = lineCompletedCheck(props, 3, false) ? AM_UserDateTime(props.recording_date, true) : null;
        props.del_date = lineCompletedCheck(props, 6, false) ? AM_UserDateTime(props.delivery_date, true) : null;
        const recStyle = !lineCompletedCheck(props, 3, true) ? "notcompleted" : "";
        const aiStyle = !lineCompletedCheck(props, 7, true) ? "notcompleted" : "";
        const postStyle = !lineCompletedCheck(props, 4, true) ? "notcompleted" : "";
        const qaStyle = !lineCompletedCheck(props, 5, true) ? "notcompleted" : "";
        const delStyle = !lineCompletedCheck(props, 6, true) ? "notcompleted" : "";

        if(precheckStyle && adaptStyle && recStyle && postStyle && qaStyle && delStyle) { return }  
    
        return `<div class="scriptTaskCompletedDiv">
                    <div id="precheck" key="precheck" class="scriptTaskCompleted pre ${precheckStyle}"></div>
                    <div id="adaptation" key="adaptation" class="scriptTaskCompleted adapt ${adaptStyle} ${adaptNotNeeded}"></div>
                    <div id="recording" key="recording" class="scriptTaskCompleted recorded ${recStyle}"></div>
                    <div id="ai" key="ai" class="scriptTaskCompleted ai ${aiStyle}"></div>
                    <div id="postpro" key="postpro" class="scriptTaskCompleted post ${postStyle}"></div>
                    <div id="qa" key="qa" class="scriptTaskCompleted qa ${qaStyle}"></div>
                    <div id="delivery" key="delivery" class="scriptTaskCompleted del ${delStyle}"></div>
                </div>`
    },[lineCompletedCheck, setXlocStatusText]);

    const getNowDate = (date) => {

        const now = date ? new Date(date) : new Date();
        const year = now.getUTCFullYear();
        const month = String(now.getUTCMonth() + 1).padStart(2, '0');
        const day = String(now.getUTCDate()).padStart(2, '0');
        const hour = String(now.getUTCHours()).padStart(2, '0');
        const min = String(now.getUTCMinutes()).padStart(2, '0');
        const seg = String(now.getUTCSeconds()).padStart(2, '0');

        return `${year}-${month}-${day} ${hour}:${min}:${seg}`;
        
    };

    const getPronunciationsTable = (scriptLanguageId) => {
        if (scriptLanguageId === '0') { return glossary.current } 
        const glossaryIds = glossaryMapping.current[scriptLanguageId];
        return glossaryIds ? glossary.current.filter(r => glossaryIds.franchise_id.includes(r.franchise_id) && r.language_id === glossaryIds.language_id) : [];
    }

    const searchPronunciationTerms = (id, text) => {
        if (!text || !glossaryMapping.current || !glossaryMapping.current[id] || !glossaryMapping.current[id].regex) { return null };
        text = '●' + text.replace(/🞀[^🞂]*🞂/g, ' ').replace(/[\s\n]/g, '●●') + '●';
        const r = glossaryMapping.current[id].regex;
        const matches = [...new Set(text.toLowerCase().match(r))];
        if (matches.length>0) {
            const finalArray= [];
            matches.forEach (r => { 
                const trimTerm = r.slice(1,-1).replace(/●●/g, ' ');

                let pronunciation = glossary.current.filter((g) => glossaryMapping.current[id].franchise_id.includes(g.franchise_id) 
                                                                && g.language_id === glossaryMapping.current[id].language_id 
                                                                && g.term.toLowerCase() === trimTerm.toLowerCase());
                if (pronunciation.length>1) {
                    let min;
                    let maxPriorityPronun;
                    pronunciation.forEach((t, idx) => {
                       let gId = glossaryMapping.current[id].franchise_id.findIndex(m => m === t.franchise_id);
                       if (idx === 0 && gId>-1) { min = gId; maxPriorityPronun=t } else if (gId<min && gId>-1) { min = gId; ; maxPriorityPronun=t }
                    })
                    pronunciation = maxPriorityPronun;
                } else {
                    pronunciation = pronunciation[0];
                }

                /*const pronunciation = glossary.current.find(g => glossaryMapping.current[id].glossary_id.includes(g.glossary_id) 
                                                                    && g.language_id === glossaryMapping.current[id].language_id 
                                                                    && g.term.toLowerCase() === trimTerm.toLowerCase());*/

                const scapeTerm=pronunciation.term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&').replace(/ /g, '●●');
                if(!finalArray.some(r => r.id === pronunciation.id)) {
                    finalArray.push({id: pronunciation.id, 
                        scapeTerm: scapeTerm, 
                        term: pronunciation.term,
                        text: pronunciation.term + ': ' + pronunciation.pronunciation, 
                        notes: pronunciation.notes, 
                        tooltip: pronunciation.notes ? pronunciation.pronunciation + '\nNotes: ' + pronunciation.notes : pronunciation.pronunciation,
                        s3_link: pronunciation.s3_link}); 
                }
            });
    
            if (finalArray) { 
                return finalArray; 
            }
        }
        return null
    }

    /*const checkPronunciations = (dataSource) => {
        if (!glossary.current) { return null };
        const newData = [...dataSource];
        let updated = false;
        newData.forEach ((r) => {
            const pronunciations = glossary.current ? searchPronunciationTerms(r.script_language_id, r[targetColumn.current]) : null;
            const pronunciationText = pronunciations ? pronunciations.map((p) => p.text).join('\n') : null;
            const oldValue = r.pronunciations_data ? JSON.stringify(r.pronunciations_data) : null;
            const newValue = pronunciations ? JSON.stringify(pronunciations) : null;
            if (oldValue !== newValue) { 
                newData[r.MyID] = {...r, pronunciations: pronunciationText, pronunciations_data: pronunciations};
                updated = true;
            };
        });
        return updated ? newData : null;
    }*/

    const addPronunciationsToDataSource = useCallback(() => {
        if (!glossary.current) { return false };
        let updated = false;
        unfilteredDataSource.current.forEach ((r) => {
            const pronunciations = glossary.current ? searchPronunciationTerms(r.script_language_id, r[targetColumn.current]) : null;
            const pronunciationText = pronunciations ? pronunciations.map((p) => p.text).join('\n') : null;
            const oldValue = r.pronunciations_data ? JSON.stringify(r.pronunciations_data) : null;
            const newValue = pronunciations ? JSON.stringify(pronunciations) : null;
            if (oldValue !== newValue) { 
                r.pronunciations = pronunciationText; r.pronunciations_data = pronunciations
                updated = true;
            };
        });
        return updated;
    },[])

    const scriptGlossariesIds = (mapping) => {
        const ids = {};
        mapping.forEach((e) => {
            franchisesData.current[e.franchise_id] = e.franchise_name;
            const existingElement = ids[e.script_language_id];
            if (existingElement) {
                existingElement.franchise_id.push(e.franchise_id);
            } else {
                ids[e.script_language_id] = { script_language_id: e.script_language_id, franchise_id: [e.franchise_id], main_id: e.main_id, language_id: e.language_id, regex: null };
            }
        } )
        return ids;
    }

    const setGlossaryData = useCallback((glossaryData) => {
        if (glossaryData && glossaryData.glossary) {
            originalData.current = glossaryData
            const idsMapping = scriptGlossariesIds(glossaryData.mapping);
            for (const key in idsMapping) {
                const mp = idsMapping[key];
                const scriptGlossary = glossaryData.glossary.filter((e) => {
                    return mp.franchise_id.includes(e.franchise_id) && e.language_id === mp.language_id;
                });
                if(scriptGlossary.length>0){
                    const scapeTerms = Array.from(scriptGlossary).map(g => g.term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&').replace(/ /g, '●●')).sort((a, b) => b.length - a.length);
                    mp.regex = new RegExp(`[^a-zA-ZÀ-ÖØ-öø-ÿ0-9А-Яа-я](?:${scapeTerms.join('|')})[^a-zA-ZÀ-ÖØ-öø-ÿ0-9А-Яа-я]`, 'gi')
                } else {
                    mp.regex = null;
                }
            }    
            glossary.current = glossaryData.glossary;   
            glossaryMapping.current = idsMapping;
        } else {
            if(glossaryData) { originalData.current = [] }
            glossary.current = [];
            glossaryMapping.current = [];
        }
    }, [])

    const reloadPronunciations = async (setPronDataSource) => {  
        if (scriptIds.current) {
            const result = await axios.get(API_ADR(`scriptGlossaries=${scriptIds.current}`));
            if (result.data.pronunciations) { 
                if (!_.isEqual(originalData.current, result.data.pronunciations)) {
                    setGlossaryData(result.data.pronunciations);
                    setClearInterval(true); 
                    setPronDataSource();    
                    if(addPronunciationsToDataSource()) { 
                        refreshColumn.current('pronunciations'); 
                        refreshColumn.current('target_asrec'); 
                        refreshColumn.current('target_adapted'); 
                        refreshColumn.current('target_text'); 
                    }
                }
            };
        }                           
    };

    const fetchPronunciations = useCallback(async ()  => {  
        if (scriptIds.current) {
            const result = await axios.get(API_ADR(`scriptGlossaries=${scriptIds.current}`));
            if (result.data.pronunciations) { 
                if (!_.isEqual(originalData.current, result.data.pronunciations)) {
                    setGlossaryData(result.data.pronunciations);
                    if(addPronunciationsToDataSource()) { 
                        refreshColumn.current('pronunciations'); 
                        refreshColumn.current('target_asrec'); 
                        refreshColumn.current('target_adapted'); 
                        refreshColumn.current('target_text'); 
                    }
                    /*if (updateAlert.current) { 
                        updateAlert.current.style.display = 'initial'
                        toast.info('New pronunciations available!\nPress refresh to update them.', { autoClose: 5000, hideProgressBar: false });
                    };*/
                }
            };
            /*if (Object.keys(sharedLinesIds.current).length > 0) { 
                checkSharedLines.current(); 
            }*/
        }                          
    }, [setGlossaryData, addPronunciationsToDataSource]);

    const altsStringFromJson = (a) => {
        if(!a || a.length === 0) { return null }
        const alts = [];
        let count = 1;
        a.forEach((a) => {
            if(a.active === 1) {
                alts.push(count + ') ' + a.alttext)
                count += 1;
            }
        })
        return alts.length > 0 ? alts.join('\n') : null
    }

    const targetFileCheck = (el) => {
        if(!el.target_filetypes || !el.target_audio) { return 'Missing'}
        let textArray = [];
        const filetypesCount = Object.keys(el.target_filetypes).length;
        Object.keys(el.target_filetypes).forEach((e) => {
            if(!el.target_audio['0'] || !Object.keys(el.target_audio['0']).includes(e)) { textArray.push(el.target_filetypes[e]) }           
        })
        if(el.alternatives_json.length > 0) {
            for (let i = 0; i < el.alternatives_json.length; i++) {
                if(el.alternatives_json[i].active === 1 && (!el.target_audio[el.alternatives_json[i].id] || Object.keys(el.target_audio[el.alternatives_json[i].id]).length < filetypesCount)) {
                    textArray.push('Alts');
                    break
                }
            }
        }
        return textArray.length > 0 ? "Missing " + textArray.join('/') : null;
    }

    const completedUpdate = useCallback((row, task, taskId, skipStatus) => {

        let val = '';
        if(row.only_context_edit === '1') { 
            val = '(Context)' 
        } else {
            const status = row[task + '_completed'] === '1' && !qaStatusData.current.tags[row.qa_tag_id].incompleted?.includes(taskId) ? 'Checked' : 'Not Checked';
            const tag = row.only_context_edit === '2' ? ' (Edit Only)' : '';
            val = status + tag;
        }
        
        row[task + '_completedString'] = val;      
        setQAStatus(row);     
        if(!skipStatus) { row.lineStatus = projectTaskProgression2(row) } 

    },[projectTaskProgression2, setQAStatus])

    const addLocalChanges = (ids, type, complete) => {
        if(!updating.current) { return }
        if(type === 0) {
            ids.forEach((i) => localSourceUpdates.current[complete ? i.id : i] = true);
        } else if(type === 1) {
            ids.forEach((i) => {
                const id = !complete ? i : i.id ? i.id : i.script_data_language_id;
                localTargetUpdates.current[id] = true
            });
        } else if(type === 2) {
            ids.forEach((id) => localSharedUpdates.current[id] = true);
        }
    }

    const updateTasksNotes = (row) => {
        let notesArray = [];
        if (row.precheck_notes) {notesArray.push('Pchk: ' + row.precheck_notes)};
        if (row.adaptation_notes) {notesArray.push('Adapt: ' + row.adaptation_notes)};
        if (row.recording_notes) {notesArray.push('Rec: ' + row.recording_notes)};
        if (row.ai_notes) {notesArray.push('Synth: ' + row.ai_notes)};
        if (row.postpro_notes) {notesArray.push('Post: ' + row.postpro_notes)};
        if (row.qa_notes) {notesArray.push('QA: ' + row.qa_notes)};
        row.tasks_notes = notesArray.join('\r\n');
    }

    const getSourceAudioLength = (row, fileType = null) => {
        const key = row.source_link_id ? '|' +  row.source_link_id.toLowerCase().replace(/\\/g, '/') : null;
        const ids = row.souce_types_id ? row.souce_types_id.split('|') : [];

        if(!fileType){
            for(const i of ids) {
                const audioLength = sourceAudioBase.current?.[i + key]?.duration;
                if(audioLength) return audioLength * 1000;
            }
        } else {
            const audioLength = sourceAudioBase.current?.[fileType + key]?.duration;
            if(audioLength) return audioLength * 1000;
        }

    }

    

    const adaptCheckSettings = useRef({positive: 5, negative: 10, paceStrength: 20});

    const setAdaptationCheck = useCallback((row) => {
        if(row.only_context_edit > 0) {
            row.adapt_check_tag = null;
            return;
        }
        const sourceText = !row.source_precheck_text ? row.source_text : row.source_precheck_text;
        if(sourceText?.replace(/\r?\n|\r/g, " ").trim() === row.target_text?.replace(/\r?\n|\r/g, " ").trim()) {
            row.adaptation_check = 'OK (Equal)';
            return;
        }

        const data = row.adaptation_check_data && typeof row.adaptation_check_data === "string" ? JSON.parse(row.adaptation_check_data) : null;

        const mult = 0.8;
        const paceStrength = adaptCheckSettings.current.paceStrength;
        const sourceLen = data ? data.source * mult : 1;
        const targetLen = data ? data.target * mult : sourceLen;
        const audioLength = !data ? null : getSourceAudioLength(row) ?? sourceLen;

        const pace = audioLength ? sourceLen / audioLength : null;
        const ignorePace = pace === null || (audioLength > 3000 && !(pace < 2 && pace > 0.5));
        const paceOffset = !ignorePace ? (paceStrength * (pace - 1)) : 0;
        const percentage = !data ? null : Math.round((100 * targetLen / sourceLen) - 100);
        const offset = Math.round(percentage + paceOffset);
        const val = ['TO CHECK'];
        if(row.tc_code === 'VO') {
            val[0] = 'OK';
        } else if(!['SS', 'LS'].includes(row.tc_code) && percentage !== null) {
            const tc = tcColors.current.find(t => t.tc_code === row.tc_code);
            if(
                !(
                    (tc.tollerance_positive !== null && offset > (parseInt(tc.tollerance_positive) + adaptCheckSettings.current.positive)) ||
                    (tc.tollerance_negative !== null && offset < -(Math.abs(tc.tollerance_negative) + adaptCheckSettings.current.negative))
                )
             ) val[0] = 'OK';
        }
        if(percentage !== null) {
            if(offset === 0) {
                val.push('(Equal)');
            } else {
                val.push(`(${Math.abs(offset)}% ${offset > 0 ? 'longer)' : 'shorter)'}`);
            }
        }
        if(!ignorePace) {
            const paceTag = pace > 1.15 && pace < 1.4 ? 'Fast' : 
                            pace > 1.4 ? 'Very fast' : 
                            pace < 0.85 && pace > 0.6 ? 'Slow' : 
                            pace < 0.6 ? 'Very slow' : 
                            'Normal';
            val.push(`(Pace: ${paceTag})`);
        }
        row.adaptation_check = val.join(' ');
    }, [])

    const manipulateDataOnTaskChange = () => {
        unfilteredDataSource.current.forEach((r) => {
            r.bug_fixing_text = setBugFixingText(r);
            r.precheck_chat_text = setPrecheckChatText(r);
            if(taskId.current === '1') checkDiffs(r);
        })
    }
  
    const checkForScriptUpdates = useCallback((fromButton, forPM, typeOfUpdate) => {
        
        if(!scriptIds.current) return;
        
        const checkQueu = () => {
            const keys = Object.keys(updateQueu.current);
            if(keys.length === 0) { return }
            const update = {...updateQueu.current};
            updateQueu.current = {};
            keys.forEach((k) => {
                if(update[k] <= lastUpdate.current[k]) {
                    delete update[k];
                }
            })
            if(Object.keys(update).length > 0) {
                checkForScriptUpdates(false, false, update);
            }     
        }

        const createIndexes = (data) => {
            dataTargetIndex.current = {};
            dataSourceIndex.current = {};
            data.forEach((r, idx) => {
                dataTargetIndex.current[r.script_data_language_id] = idx;
                dataSourceIndex.current[r.script_data_id] = idx;
            })
        }

        const finalizePMUpdate = (adapt) => {
            const data = adapt ? unfilteredDataSource.current : temporalDatasource.current
            refreshPMUpdates.current(true, data);
            temporalDatasource.current = [];
            pmUpdatePending.current = 0;
            updating.current = false;
            updateProgressBar(-1, null, 2);
            if(adapt) { 
                checkForScriptUpdates(true); 
            } else {
                checkQueu();
            }
        }

        const refreshPMUpdate = (changeDs) => {
            updating.current = true;
            if(!changeDs && taskId.current === '2') {
                finalizePMUpdate(true);
                return
            } else if(changeDs) {
                createIndexes(temporalDatasource.current);
                checkForScriptUpdates(true, true);
                return
            }
            pmUpdatePending.current = 0;
            if(refreshPMUpdates.current) { refreshPMUpdates.current() }      
            updating.current = false;
            if(updateCounter.current) { updateCounter.current() };
            updateQueu.current = {};

            checkForScriptUpdates(true);        
        }

        if(fromButton && pmUpdatePending.current > 0 && !forPM) {
            updating.current = true;
            refreshPMUpdate(pmUpdatePending.current === 1);
            return
        } else if(pmUpdatePending.current === 1 && !forPM) {
            toast.info('There is an update from the PM for this script.\nPress the refresh button to update the script.', {hideProgressBar: false, position: "top-center"})
            return
        }

        const extensions = ["wav", "aif", "aiff", "flac", "mp3", "ogg", "aac", "m4a", "mp4", "mov", "avi", 'mkv', "wmv", "wma"];

        const getKeyName = (fileName, removeExt) => {
            if(!fileName) { return }
            if(removeExt) {
                const extensionDot = fileName.lastIndexOf('.');
                if(extensionDot > -1) { 
                    const extension = fileName.split('.').pop().toLowerCase();
                    fileName = !extensions.includes(extension) ? fileName : fileName.slice(0, extensionDot);
                }; 
            }
            return fileName.toLowerCase().replace(/\\/g, '/');
        }

        const addHistoryId = (row, field) => {
            if(!row.history_columns) {
                row.history_columns = field;
            } else if(!row.history_columns.split(",").includes(field)) {
                row.history_columns += ',' + field;  
            }    
        }

        const removeAdaptMarkers = (text) => {
            return text ? text.replace(/\u00A0/g, '♚').replace(/🞀[^🞂]+🞂/g, ' ').replace(/\u00A0/g, '').replace(/ {2,}/g, ' ').replace(/♚/g, '\u00A0').trim() : null;
        }

        const autoFillJsonKeys = (el) => {
            el.source_precheck_text_wasnull = false
            el.target_adapted_wasnull = false
            el.target_asrec_wasnull = false
    
            if(el.source_precheck_text === null){
                el.source_precheck_text_wasnull = true
                el.source_precheck_text = el.source_text
            }
            if(el.target_adapted === null){
                el.target_adapted_wasnull = true
                el.target_adapted = el.target_text
            }
            if(el.ai_tts === null){
                el.ai_tts = el.target_adapted
            }
            if(el.target_asrec === null){
                el.target_asrec_wasnull = true
                el.target_asrec = el.target_adapted
            }
            if(el.shared_line_id && el.deactivate_shared_line === '0') {
                el['target_adapted_beforeShared'] = el.target_adapted;
                el['target_asrec_beforeShared'] = el.target_asrec ? el.target_asrec : el.target_adapted ? removeAdaptMarkers(el.target_adapted) : null;
            }
            if(el.locked_text !== null && el.shared_line_id && el.deactivate_shared_line === '0') {
                el.target_adapted_wasnull = false
                el.target_asrec_wasnull = false
                el.target_adapted = el.locked_text
                el.target_asrec = removeAdaptMarkers(el.locked_text)
            }
        }

        const addPronunciations = (r) => {
            const pronunciations = glossary.current ? searchPronunciationTerms(r.script_language_id, r[targetColumn.current]) : null;
            const pronunciationText = pronunciations ? pronunciations.map((p) => p.text).join('\n') : null;
            const oldValue = r.pronunciations_data ? JSON.stringify(r.pronunciations_data) : null;
            const newValue = pronunciations ? JSON.stringify(pronunciations) : null;
            if (oldValue !== newValue) { 
                r.pronunciations = pronunciationText; 
                r.pronunciations_data = pronunciations;
                return true;
            };
            return false
        }

        const addSourceFiles = (r) => {
            if(!r.souce_types_id) {
                if(r.source_audio) { r.source_audio = null };
                return
            }
            const filetypesIds = r.souce_types_id.split('|');
            const filetypesNames = r.souce_types_name.split('|');
            const missingFiles = [];  
            if(filetypesIds && filetypesIds.length > 0) {
                filetypesIds.forEach((f, idx) => {
                    const videoKey = r.cinematic_name ? sourceAudioBase.current?.[f  + '|' + r.script_id + '|' + getKeyName(r.cinematic_name, true)] : undefined;
                    const audioKey = sourceAudioBase.current?.[f  + '|' +  getKeyName(r.source_link_id)];
                    const file = audioKey || videoKey;
                    if(!file?.s3) {
                        missingFiles.push(filetypesNames[idx])
                    } else if(file?.markers) {
                        markersArray.current[extractID(file.s3)] = JSON.parse(file.markers)
                    }                    
                })
            }
            const text = missingFiles.length > 0 ? 'Missing ' + missingFiles.join('/') : null;
            r.source_audio = text;
        }

        const fillPronSourceMissing = (updateAudiobase, updatePronunciations, updateActors, forceUnlockUpdated, forPMUpdate, tgFiletypes, targetAudioData, updateScriptSettings, updateScriptSites, updateXlocStatus) => {

            const destDataSorce = !forPMUpdate ? unfilteredDataSource.current : temporalDatasource.current;

            localSourceUpdates.current = {};
            localTargetUpdates.current = {};
            localSharedUpdates.current = {};

            let updatePronCol = false;
            let updateActorCol = false;
            let updateRecSiteCol = false;
            
            const callback = (data) => {
                data.forEach((r) => {
                    if(updatePronunciations) { updatePronCol = addPronunciations(r) ? true : updatePronCol }
                    if(updateActors && updateActors[r.script_language_id]) { 
                        const actor = updateActors[r.script_language_id][r.character_id];
                        if(actor !== r.actor_name) {
                            r.actor_name = actor;
                            updateActorCol = true;
                        }
                    }
                    if(tgFiletypes?.[r.script_id]) { 
                        r.target_filetypes = tgFiletypes[r.script_id];
                        r.target_audio = targetAudioData?.[r.script_data_language_id]; 
                        r.target_file_check = targetFileCheck(r);  
                    }
                    if(updateScriptSites) {
                        const siteId = r.recording_site_id;
                        const scriptLangId = r.script_language_id;
                        const siteCode = scriptSettings.current?.[scriptLangId]?.tasksInfo?.[3].recSites?.[siteId]?.code ?? 'Unassigned';
                        if(siteCode !== r.rec_site) {
                            r.rec_site = siteCode;
                            updateRecSiteCol = true;
                        }
                    }
                    if(updateXlocStatus) setXlocStatusText(r);
                    if(!updateAudiobase) { return }
                    addSourceFiles(r);
                    if(taskId.current === '1') checkDiffs(r);
                })
            }

            let index = 0;
            const steps = 999;
            const arrayLength = destDataSorce.length;

            const processNext = () => {
                if (index >= arrayLength) {
                    if(forPMUpdate) { 
                        finalizePMUpdate();
                        return 
                    }
                    if(forceUnlockUpdated || updateScriptSettings) { 
                        refreshAll.current(); 
                    } else {
                        if(updatePronCol) {
                            refreshColumn.current('pronunciations'); 
                            refreshColumn.current('target_asrec'); 
                            refreshColumn.current('target_adapted'); 
                            refreshColumn.current('target_text'); 
                        }
                        if(updateAudiobase) { 
                            refreshColumn.current('source_audio');
                            refreshColumn.current('precheck_check');
                            refreshColumn.current('audio_transcription');
                         }
                        if(updateActorCol) { refreshColumn.current('actor_name') }
                        if(tgFiletypes) { 
                            refreshColumn.current('target_file_check'); 
                            refreshColumn.current('alternatives'); 
                        }
                        if(updateRecSiteCol) { refreshColumn.current('rec_site') }
                    }
                    if(updateSidePanel.current) { updateSidePanel.current() }
                    if(refreshActorScript.current) { refreshActorScript.current() };
                    updateProgressBar(-1, null, 2);
                    updating.current = false;
                    checkQueu();
                    return;
                }                                  
                callback(destDataSorce.slice(index, steps + index));
                index += steps + 1;
                if(index>arrayLength) { index = arrayLength }
                setTimeout(processNext, 0);
                updateProgressBar((index/arrayLength)*100, "Updating audiobase", 2);
            }    
            processNext();

        }

        const checkChanges = (updatedData, updateAudioBase, updatePronunciations, updateActors, forceUnlockUpdated, forPMupdate, tgFiletypes, targetAudioData, updateScriptSettings, updateScriptSites, updateXlocStatus) => {

            const destDataSorce = !forPMupdate ? unfilteredDataSource.current : temporalDatasource.current;

            const callbackFunction = (data) => {
                data.forEach((r) => {
                    const type = r.script_data_id ? 0 : 1;
                    let row = null;
                    let rows = null;
                    if(type === 1) {
                        const id = dataTargetIndex.current[r.script_data_language_id];
                        if(isNaN(id)) { return }
                        row = destDataSorce[id];
                    } else {
                        const ids = dataSourceIndex.current[r.script_data_id];
                        if(!ids) { return }
                        rows = ids.map(idx => destDataSorce[idx]);
                        row = rows[0];
                    }

                    if(row) {

                        let update = false;
                        let updateNotes = false;
                        let updateComplete = false;

                        const ignoreUpdate = type === 0 ? 
                                            localSourceUpdates.current[r.script_data_id] :
                                            localTargetUpdates.current[r.script_data_language_id] || localSharedUpdates.current[r.shared_line_id];
                        if(ignoreUpdate) { return }

                        Object.keys(r).forEach((f) => {

                            let currentVal = row[f];
                            let compareVal = r[f];
                            let newVal = r[f];
                            if(['alternatives_json','ai_tts_settings','bug_fixing_notes','precheck_chat_notes','target_audio', 'qa_status_log', 'xloc_status'].includes(f)){
                                currentVal = JSON.stringify(currentVal);
                                try { 
                                    newVal = newVal ? JSON.parse(newVal) : [];
                                    compareVal = JSON.stringify(newVal); 
                                } catch (error) {}  
                            } else if(f === 'target_asrec') {
                                newVal = newVal ? newVal.replace(/\u00A0/g, '♚').replace(/🞀[^🞂]+🞂/g, ' ').replace(/\u00A0/g, '').replace(/ {2,}/g, ' ').replace(/♚/g, '\u00A0').trim() : null;                                
                            }             
                            if(currentVal !== compareVal) {
                                update = true;
                                if(rows) { 
                                    rows.forEach((r) => { 
                                        r[f] = newVal;
                                        if(['qa_completed', 'qa_tag_id'].includes(f)) setQAStatus(r);
                                        if(!['xloc_status','upload_tag_id','section_name','rec_site'].includes(f)) addHistoryId(r,f); 
                                        if(f === 'adaptation_check_data') setAdaptationCheck(r);
                                    })
                                } else {
                                    row[f] = newVal;
                                    if(['qa_completed', 'qa_tag_id'].includes(f)) setQAStatus(row);
                                    if(!['xloc_status','upload_tag_id','section_name','rec_site'].includes(f)) addHistoryId(row,f);
                                    if(f === 'adaptation_check_data') setAdaptationCheck(row);
                                }              
                                //if(f === 'upload_tag_id') { 
                                //    const tagData = uploadTags.current?.[newVal];
                                //    row.uploadTags = tagData ? `${tagData.tag} (${tagData.user} on ${AM_UserDateTime(tagData.date)})` : null;
                                //}
                                if(f === 'alternatives_json') { row.alternatives = altsStringFromJson(newVal) }
                                if(f === 'bug_fixing_notes') { row.bug_fixing_text = setBugFixingText(row) }
                                if(f === 'precheck_chat_notes') { row.precheck_chat_text = setPrecheckChatText(row) }
                                if(f === 'qa_notes') { row.bug_fixing_text = setBugFixingText(row) }
                                if(f === 'target_audio') { 
                                    row.target_file_check = targetFileCheck(row); 
                                    if(row.target_audio){                   
                                        Object.values(row.target_audio).forEach(e => {
                                            Object.values(e).forEach(t => {
                                                if(t?.markers){
                                                    markersArray.current[extractID(t?.s3)] = JSON.parse(t?.markers)
                                                }
                                            })
                                        })
                                    }
                                    setUploadTagsValues(row);
                                    updateComplete = true;
                                }
                                if(f.includes('_completed') || f === 'qa_tag_id') { updateComplete = true }
                                if(f.includes('_notes') && f !== 'language_notes' && f !== 'pm_notes') { updateNotes = true }
                                if(f === 'target_adapted' || (f === 'target_asrec' && (['qa','delivery','postpro'].includes(liveTask.current)))){
                                    if (f === 'target_asrec' || (!['qa','delivery','postpro'].includes(liveTask.current))) {
                                        const pronunciations = searchPronunciationTerms(row.script_language_id, row[f]);
                                        const pronunciationText = pronunciations ? pronunciations.map((p) => p.text).join('\n') : null;
                                        const oldValue = row.pronunciations_data ? JSON.stringify(row.pronunciations_data) : null;
                                        const newValue = pronunciations ? JSON.stringify(pronunciations) : null;
                                        if (oldValue !== newValue) {
                                            row.pronunciations = pronunciationText;
                                            row.pronunciations_data = pronunciations;
                                        }
                                    };
                                }
                                if(f === 'recording_site_id') {
                                    updateScriptSites = true;
                                }
                                if(f === 'xloc_status') setXlocStatusText(row);
                                // TTS RIGHT PANEL
                                if(['ai_tts_settings', 'ai_tts_status', 'ai_tts', 'target_audio'].includes(f)){
                                    if(selectedId.current === row.MyID && updateTTSPanel.current){
                                        updateTTSPanel.current(row);
                                    }
                                }    
                            } 

                        })
                        if(updateComplete) { completedUpdate(row, liveTask.current, parseInt(taskId.current)) }
                        if(update && rows) { 
                            rows.forEach((r) => { 
                                if(updateNotes) { updateTasksNotes(r) }
                                if(!forPMupdate) { 
                                    if(!updateScriptSettings) { refreshRow.current(r.MyID) };
                                    if(selectedId.current === r.MyID && updateSidePanel.current) { updateSidePanel.current() } 
                                }
                            }); 
                        } else if(update) {
                            if(updateNotes) { updateTasksNotes(row) }
                            if(!forPMupdate) {
                                if(!updateScriptSettings) { refreshRow.current(row.MyID) };
                                if(selectedId.current === row.MyID && updateSidePanel.current) { updateSidePanel.current() } 
                            }
                        }
                    }            
                })      
            }
  
            let index = 0;
            const steps = 100;
            const arrayLength = updatedData.length;

            const processNext = () => {
                if (index < arrayLength) {
                    callbackFunction(updatedData.slice(index, steps + index));
                    index = steps + index;
                    if(index>arrayLength) { index = arrayLength }
                    setTimeout(processNext, 0);
                    updateProgressBar((index/arrayLength)*100, "Updating script", 2);
                } else if(updateAudioBase || updatePronunciations || updateActors || updateScriptSites || updateXlocStatus) {
                    fillPronSourceMissing(updateAudioBase, updatePronunciations, updateActors, forceUnlockUpdated, forPMupdate, tgFiletypes, targetAudioData, updateScriptSettings, updateScriptSites);
                } else {
                    if(forPMupdate) { 
                        finalizePMUpdate();
                        return 
                    }
                    if(forceUnlockUpdated || updateScriptSettings) { refreshAll.current() }
                    if(refreshActorScript.current) { refreshActorScript.current() };
                    if(updateCounter.current) { updateCounter.current() };
                    updateProgressBar(-1, null, 2);
                    updating.current = false;
                    localSourceUpdates.current = {};
                    localTargetUpdates.current = {};
                    localSharedUpdates.current = {};
                    checkQueu();
                };
            }    
            processNext();

        }

        const sortByFields = (fields) => {
            return (a, b) => {
                for (let field of fields) {
                    if (a[field] < b[field]) {
                        return -1;
                    }
                    if (a[field] > b[field]) {
                        return 1;
                    }
                }
                return 0;
            };
        }

        const finalizeUpdate = (data, sort) => {

            if(sort) data.sort(sortByFields(['project_id', 'batch_id', 'script_id', 'script_order', 'language_id']));

            const sourceFields = ['source_precheck_text', 'fx', 'precheck_notes', 'precheck_chat_notes', 'precheck_completed', 'precheck_date', 'precheck_resource_name', 'pm_notes', 'navigation_id'];
            const targetFields = [
                'locked_text', 'locked', 'deactivate_shared_line',
                'activated_line', 'deactivated_line', 'target_adapted', 'target_asrec', 'alternatives_json',
                'language_notes', 'adaptation_notes', 'recording_notes', 'ai_notes', 'postpro_notes', 'qa_notes',
                'qa_tag_id', 'qa_tag_severity_id', 'bug_fixing_notes', 'qa_status',
                'adaptation_completed', 'adaptation_date', 'adaptation_resource_name',
                'recording_completed', 'recording_date', 'recording_resource_name',
                'ai_completed', 'ai_date', 'ai_resource_name',
                'postpro_completed', 'postpro_date', 'postpro_resource_name',
                'qa_completed', 'qa_date', 'qa_resource_name',
                'delivery_completed', 'delivery_date', 'delivery_resource_name',
                'ai_tts', 'ai_tts_settings', 'ai_tts_tone_description', 'qa_status_log'
            ];
            const jsonFields = ['alternatives_json', 'bug_fixing_notes', 'precheck_chat_notes', 'target_audio', 'target_filetypes', 'ai_tts_settings', 'pronunciations_data', 'qa_status_log'];
            let contextLines = false;
            const scriptIndex = {};
            const scriptSourceIndex = {};

            const differentCount = data.length !== unfilteredDataSource.current.length;
            let isDifferent = false;
            const toUpdate = [];

            const callback = (dataPart, offset) => {

                dataPart.forEach(function(el, idx){

                    const currentIdx = dataTargetIndex.current[el.script_data_language_id];
                    isDifferent = currentIdx === (idx + offset) ? isDifferent : true;

                    scriptIndex[el.script_data_language_id] = idx + offset;
                    if(!scriptSourceIndex[el.script_data_id]) { scriptSourceIndex[el.script_data_id] = [] }
                    scriptSourceIndex[el.script_data_id].push(idx + offset);
                        
                    contextLines = contextLines ? true : el.only_context_edit !== '0';
                    el.MyID = idx + offset;

                    let jsonAlts = [];
                    try { jsonAlts = el.alternatives ? JSON.parse(el.alternatives) : [] } catch (error) {}          
                    el.alternatives_json = jsonAlts;
                    el.alternatives = altsStringFromJson(el.alternatives_json)

                    try { el.bug_fixing_notes = el.bug_fixing_notes ? JSON.parse(el.bug_fixing_notes) : el.bug_fixing_notes } catch (error) {} ;
                    try { el.precheck_chat_notes = el.precheck_chat_notes ? JSON.parse(el.precheck_chat_notes) : el.precheck_chat_notes } catch (error) {} ;
                    try { el.bug_fixing_text = setBugFixingText(el) } catch (error) {} ;
                    try { el.precheck_chat_text = setPrecheckChatText(el) } catch (error) {} ;
                    
                    try { el.target_audio = el.target_audio ? JSON.parse(el.target_audio) : el.target_audio } catch (error) {} ;
                    try { el.target_filetypes = el.target_filetypes ? JSON.parse(el.target_filetypes) : el.target_filetypes } catch (error) {} ;
                    try { el.ai_tts_settings = el.ai_tts_settings ? JSON.parse(el.ai_tts_settings) : null } catch (error) {};
                    try { el.qa_status_log = el.qa_status_log ? JSON.parse(el.qa_status_log) : null } catch (error) {};

                    completedUpdate(el, 1,'precheck', true);
                    completedUpdate(el, 2,'adaptation', true);
                    completedUpdate(el, 3, 'recording', true);
                    completedUpdate(el, 4, 'postpro', true);
                    completedUpdate(el, 5, 'qa', true);
                    completedUpdate(el, 6, 'delivery', false);
                    completedUpdate(el, 7, 'ai', true);
                    el.target_file_check = targetFileCheck(el)

                    autoFillJsonKeys(el)
                    addSourceFiles(el);
                    addPronunciations(el);
                    if(taskId.current === '1') checkDiffs(el);

                    if(!differentCount && !isDifferent) {
                        const currentRow = unfilteredDataSource.current[currentIdx];
                        Object.keys(el).forEach((f) => {
                            const isJson = jsonFields.includes(f);
                            const oldVal = isJson && currentRow[f] ? JSON.stringify(currentRow[f]) : currentRow[f];
                            const newVal = isJson && el[f] ? JSON.stringify(el[f]) : el[f];
                            if(oldVal !== newVal) { 
                                toUpdate.push({idx: idx + offset, targetIdx: el.script_data_language_id, sourceIdx: el.script_data_id, field: f}) 
                            }
                        })
                    }

                })
            }

            let index = 0;
            const steps = 999;
            const arrayLength = data.length;

            const processNext = () => {
                if (index < arrayLength) {
                    callback(data.slice(index, steps + index), index);
                    index += steps + 1;
                    if(index>arrayLength) { index = arrayLength }
                    setTimeout(processNext, 0);
                    updateProgressBar((index/arrayLength)*100, "Updating audiobase", 2);
                } else {
                    ending()
                } 
            }    
            processNext();

            const ending = () => {

                if(!differentCount && !isDifferent) {
                    const rowsToRefresh = {};
                    toUpdate.forEach((u) => {
                        const ignore = (sourceFields.includes(u.field) && localSourceUpdates.current[u.sourceIdx]) || 
                                        (targetFields.includes(u.field) && localTargetUpdates.current[u.sourceIdx])
                        if(!ignore) {
                            unfilteredDataSource.current[dataTargetIndex.current[u.targetIdx]][u.field] = data[u.idx][u.field];  
                            rowsToRefresh[u.idx] = true;    
                        }
                    })
                    containsContextLines.current = contextLines;
                    Object.keys(rowsToRefresh).forEach((k) => {
                        refreshRow.current(parseInt(k));
                    });    
                    if(toUpdate.length > 0) {
                        if(refreshActorScript.current) { refreshActorScript.current() };
                        if(updateSidePanel.current) { updateSidePanel.current() }
                        pmUpdatePending.current = 2;  
                    } else {
                        pmUpdatePending.current = 0; 
                    }
                } else {
                    temporalDatasource.current = data;
                    pmUpdatePending.current = 1;  
                }  
                
                updateProgressBar(-1, null, 2);
                updating.current = false;
                localSourceUpdates.current = {};
                localTargetUpdates.current = {};
                localSharedUpdates.current = {};

                if(pmUpdatePending.current === 0) { 
                    checkQueu();
                    return; 
                }
    
                if(!fromButton) { 
                    toast.info('There is an update from the PM for this script.\nPress the refresh button to update the script.', {hideProgressBar: false, position: "top-center"}) 
                    if(pmUpdatePending.current === 2) { 
                        checkForScriptUpdates();
                        if(updateCounter.current) { updateCounter.current() };
                    } else {
                        checkQueu();
                    }  
                } else {
                    refreshPMUpdate(pmUpdatePending.current === 1);
                }

            }
            
        }

        const getScriptPart = async(data, slIds) => {

            const idsLeft = slIds.slice(scriptLinesLimit.current, scriptLinesLimit.current * 2);
            const idsToGet = slIds.slice(0, scriptLinesLimit.current);

            const headers = { 'Content-Type': 'text/plain' };
            const dataObj = {scriptLangIds: scriptIds.current, slIds: idsToGet}
            const ObjectToDB = JSON.stringify(dataObj);     
            const link = API_ADR(`getScriptUpdatesPart=1`);
            await axios.post(link, ObjectToDB, {headers}
            ).then(function (response) {
                data = [...data, ...response.data.script];
                if(idsLeft.length > 0) {
                    getScriptPart(data, idsLeft);
                } else {
                    finalizeUpdate(data, true);
                }
            })
        }

        const getUpdates = async(forPMupdate, typeOfUpdate) => {
            
            if(fromButton) { updateProgressBar(0, 'Checking updates', 2) };
            const headers = { 'Content-Type': 'text/plain' };
            if(!typeOfUpdate) { typeOfUpdate = lastUpdate.current }
            const data = {scriptLangIds: scriptIds.current, typeOfUpdate}
            const ObjectToDB = JSON.stringify(data);     
            const link = API_ADR(`getScriptUpdates=1`);
            updating.current = true;
            localTargetUpdates.current = {};
            localSourceUpdates.current = {};
            localSharedUpdates.current = {};
            const prevUpdate = {...lastUpdate.current};
            await axios.post(link, ObjectToDB, {headers}
            ).then(function (response) {

                setLastUpdate(response.data.last_update, typeOfUpdate);

                let updateScriptSettings = false;
                let updateScriptSites = false;
                let updateXlocStatus = false;
                if(response.data.scriptSettings) {
                    const scriptSettingsParsed = JSON.parse(response.data.scriptSettings.scriptSettings, '{}');
                    if(JSON.stringify(scriptSettingsParsed) !== JSON.stringify(scriptSettings.current)) {
                        Object.entries(scriptSettingsParsed).forEach(([k, v])=> {
                            if(!updateScriptSites) {
                                const recSites = v.tasksInfo?.[3]?.recSites ?? {};
                                const oldRecSites = scriptSettings.current?.[k]?.tasksInfo?.[3]?.recSites ?? {};
                                updateScriptSites = JSON.stringify(recSites) !== JSON.stringify(oldRecSites);
                            }
                            if(
                                !updateXlocStatus && 
                                (
                                    v.xlocUpdateAsrec !== scriptSettings.current?.[k]?.xlocUpdateAsrec || 
                                    v.xlocUpdateStatus !== scriptSettings.current?.[k]?.xlocUpdateStatus ||
                                    v.xlocUpdateAudio !== scriptSettings.current?.[k]?.xlocUpdateAudio
                                )
                            ) {
                                updateXlocStatus = true;
                            }
                        })
                        scriptSettings.current = scriptSettingsParsed;
                        asRecConfirm.current = Object.values(scriptSettings.current).some(v => v.asrecConfirmation === 1); 
                        if(!asRecConfirm.current) asRecMode.current = false;
                        ctx.refreshComponents?.(null, 'asrecConfirm');
                        updateScriptSettings = true;
                    }
                }

                if(response.data.extracolumns) {
                    extraColumnsHeaders.current = JSON.parse(response.data.extracolumns?.[0]?.headers_json ?? '{}');
                }

                if(response.data.targetSettings?.[0]?.filetypes) {
                    const ts = JSON.parse(response.data.targetSettings[0].filetypes);
                    Object.entries(ts)?.forEach(([k, v]) => { 
                        targetFiletypes.current[k] = v 
                    });
                }
                
                let forceUnlockUpdated = false;
                if(response.data.unlockedScripts) {
                    const unlockedScripts = JSON.parse(response.data.unlockedScripts[0].json_obj ?? '{}');
                    if(JSON.stringify(forceUnlock.current) !== JSON.stringify(unlockedScripts)) { 
                        const newLocked = Object.values(unlockedScripts).some((o) => o.hasOwnProperty(taskId.current));
                        const oldLocked = Object.values(forceUnlock.current).some((o) => o.hasOwnProperty(taskId.current));
                        forceUnlock.current = unlockedScripts; 
                        forceUnlockUpdated = oldLocked !== newLocked
                    }
                }

                const updatePronunciations = response.data.pronunciations && !_.isEqual(originalData.current, response.data.pronunciations);
                if (updatePronunciations) { 
                    setGlossaryData(response.data.pronunciations);
                    setPronGridDatasource.current(); 
                }

                const updateAudioBase = response.data.hasOwnProperty('sourceaudio');
                if(updateAudioBase) {
                    sourceAudioBase.current = JSON.parse(response.data?.sourceaudio?.[0]?.audiobase ?? '{}');
                    sourceFileTypes.current = JSON.parse(response.data?.sourceaudio?.[0]?.fileTypes ?? '{}');
                }

                const updateAdaptMetrics = response.data.hasOwnProperty('adaptMetrics');
                let updateMetrics = false;
                if(updateAdaptMetrics) {
                    const isAdapt = parseInt(taskId.current) === 2;
                    response.data.adaptMetrics?.forEach(r => {
                        const id = dataTargetIndex.current?.[r.script_data_language_id];
                        const row = unfilteredDataSource.current?.[id];
                        if(row) {
                            row.adaptation_estimation = r.adaptation_estimation;
                            updateMetrics = isAdapt;
                        }
                    })
                    if(updateMetrics) updateCounter.current?.();
                }

                /* It's a PM update */
                if(response.data.script) {
                    const script = response.data.script.script;
                    const resources = response.data.script.resources;
                    const characters = response.data.script.characters;
                    script.forEach(r => addDataAndNormalize(r, resources, characters)); 
                    if(response.data.slIds) {
                        scriptLinesLimit.current = response.data.limit;
                        getScriptPart(script, response.data.slIds);
                        return
                    } else {
                        finalizeUpdate(script);
                        return
                    }
                }

                let tgFiletypes = JSON.parse(response.data?.targetAudio?.shift()?.target_audio ?? null);
                tgFiletypes = tgFiletypes && Object.keys(tgFiletypes).length > 0 ? tgFiletypes : null;
                const targetAudioData = JSON.parse(response.data?.targetAudio?.[0]?.target_audio ?? null);

                const updateActors = response.data?.actors ?? null;
                const resources = response.data.resources;
                if(updateActors) {
                    Object.values(updateActors).forEach(v => {
                        Object.entries(v).forEach(([k, i]) => {
                            v[k] = resources[i] ?? null;
                        })
                    })
                }
                /* It's not a PM update */
                if(!response.data.target) { 
                    response.data.target = []; 
                } else {
                    response.data.target.forEach(r => addDataAndNormalize(r, resources));
                };
                if(!response.data.source) { 
                    response.data.source = [];
                } else {
                    response.data.source.forEach(r => addDataAndNormalize(r, resources));
                };

                if(response.data?.uploadTags) { uploadTags.current = { ...uploadTags.current, ...(response.data.uploadTags ?? {}) }; };

                const joinedData = [...response.data.target, ...response.data.source];
                if(joinedData?.length > 0) { 
                    checkChanges(joinedData, updateAudioBase, updatePronunciations, updateActors, forceUnlockUpdated, forPMupdate, tgFiletypes, targetAudioData, updateScriptSettings, updateScriptSites, updateXlocStatus);
                } else if(updateAudioBase || updatePronunciations || updateActors || tgFiletypes || targetAudioData || updateScriptSites || updateXlocStatus) {
                    fillPronSourceMissing(updateAudioBase, updatePronunciations, updateActors, forceUnlockUpdated, forPMupdate, tgFiletypes, targetAudioData, updateScriptSettings, updateScriptSites, updateXlocStatus);
                } else if(forPMupdate) {
                    finalizePMUpdate();
                } else {
                    if(forceUnlockUpdated || updateScriptSettings || updateMetrics) {
                        refreshAll?.current();
                    /*} else if(updateScriptSettings) {
                        refreshColumn.current('bug_fixing_text');*/
                    }
                    updateProgressBar(-1, null, 2);
                    updating.current = false;
                    checkQueu();
                }
            }).catch(function (error) {
                //console.log("ERROR", error);
                lastUpdate.current = prevUpdate;
                updateProgressBar(-1, null, 2);
                updating.current = false;
                checkQueu();
            }); 
        }
        getUpdates(forPM, typeOfUpdate);    
    },[checkDiffs, completedUpdate, ctx, setAdaptationCheck, setBugFixingText, setGlossaryData, setPrecheckChatText, setQAStatus, setXlocStatusText])

    const updateQueu = useRef({});
    
    const updateFromWebSocket = useCallback((message, force = false) => {
        if(force) {
            checkForScriptUpdates(true);
            return;
        }
        if(AM_socketId() === message.userId) { return } 
        const type = message.updateType;
        if(message.lastUpdate < lastUpdate.current[type]) { return }
        if(updating.current || Object.keys(updateQueu.current).length > 0) {
            if (!updateQueu.current.hasOwnProperty(type)) {
                updateQueu.current[type] = message.lastUpdate;
            }           
        } else if(!updating.current) {
            const updateObj = {};
            updateObj[type] = message.lastUpdate;
            checkForScriptUpdates(false, false, updateObj);
        }   
    }, [checkForScriptUpdates])
    
    //Adds webSocket update funcion to InfoContext
    useEffect(() => {
        if(ctx.webSocketFunctions.current) ctx.webSocketFunctions.current['script'] = updateFromWebSocket;

        return () => delete ctx.webSocketFunctions.current?.['script'];
    }, [ctx.webSocketFunctions, updateFromWebSocket]);
    
    const setClearInterval = useCallback((value) => {
        if(intervalId.current) {
            clearInterval(intervalId.current);
            intervalId.current = null;
        }
        if (!value) { return }
        intervalId.current = setInterval(() => { 
            if(updating.current || AM_socketId()) { return }
            checkForScriptUpdates();
        }, 60000);
    }, [checkForScriptUpdates]);

    useEffect(() => {
        if (scriptIds.current) { setClearInterval(true) };
        return () => setClearInterval(false);       
    }, [setClearInterval]);

    return (
        <PronunciationContext.Provider value={{ scriptIds, glossary, glossaryMapping, setGlossaryData, addPronunciationsToDataSource, targetColumn, liveTask, taskId,
                                                searchPronunciationTerms, fetchPronunciations, setClearInterval, updateAlert, highlightChanges,
                                                getPronunciationsTable, reloadPronunciations, scriptPersistence, dataSource, refreshColumn, unfilteredDataSource,
                                                qaStatusTags, undoState, multiSelection, playManual, actorsWindow, actorsWindowCheck, setPronGridDatasource,
                                                editPermissions, getNowDate, selChar, changeQaStatusOnComplete, projectTaskProgression2,
                                                extPlayerRef, extPlayerRefCheck, extVPlayerRef, activeLoopFromAudioModal, extVPlayerRefCheck, previousFiletype, tcColors,
                                                rolesData, extraColumnsHeaders, forceUnlock, tasksData, sidePanelsColumns, sharedLinesOptions, audioMateRoles,
                                                breadcrumb, projectData, checkEnabled, externalUser, qaTags, containsContextLines, activeroles, userRoles, sharedLinesExist, refreshActorScript,
                                                checkForScriptUpdates, lastUpdate, dataSourceIndex, dataTargetIndex, refreshRow, refreshAll, localTargetUpdates, localSourceUpdates, 
                                                updating, localSharedUpdates, addLocalChanges, progBar, progBarUpdate, updateProgressBar, updateSidePanel, updateTTSPanel, selectedId, sourceAudioBase,
                                                refreshPMUpdates, updateCounter, qaStatusData, lineCompletedCheck, scriptSettings, setLastUpdate, checkDeactivated,
                                                targetFiletypes, setBugFixingText, syncActorPannel, fieldToCopy, fieldToCopyColumns, uploadTags, recStudioLocked, xlocLineStatus, markersArray,
                                                xlocAudio, afterFilterData, setXlocStatusText, condFormatColumns, conditionalFormats, getConditionalColor, setConditionalFormat, 
                                                actorScriptSettings, asRecMode, asrecFilter, asRecConfirm, storedLine, linkPrevSelLine, broadCastToReaper, getQaStatusMappedId, setQAStatus,
                                                setUploadTagsValues, setQATag, deliveryScriptLocked, manipulateDataOnTaskChange, qaCoordOverride, setAdaptationCheck, headerOptions,
                                                columnsPermissions, adaptCheckSettings, checkDiffs, altsStringFromJson, showTranscription, filetypesFilter, changePrecheckFiletype, setFiletypes, 
                                                sourceFileTypes, sharedLinesMenuRef, setPrecheckChatText, checkTargetFileExists, franchisesData, resourceReplaceFields, addDataAndNormalize,
                                                kamFileTypesMap
                                            }}>
        {children}
        </PronunciationContext.Provider>
  );

};

export { PronunciationContext, PronunciationsContextProvider };